import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:5000/api');
const BASE = `${API_BASE_URL}/expenses`;

const ExpenseService = {
  // `channel` is an analytics channel id, 'general', or omitted for all.
  async list(rangeQuery, channel) {
    return (await axios.get(BASE, { params: { ...rangeQuery, channel: channel || undefined } })).data;
  },
  async create(expense) {
    return (await axios.post(BASE, expense)).data;
  },
  async update(id, changes) {
    return (await axios.patch(`${BASE}/${id}`, changes)).data;
  },
  async remove(id) {
    await axios.delete(`${BASE}/${id}`);
  },
};

export default ExpenseService;
